/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { Theme } from '@coursera/cds-core';
import { useTheme } from '@coursera/cds-core';

import _t from 'i18n!nls/compound-assessments';

const style = {
  root: (theme: Theme, isMultiLine: boolean, isEmpty: boolean) =>
    css({
      backgroundColor: 'var(--cds-color-grey-25)',
      borderStyle: 'solid',
      borderWidth: '1px',
      borderColor: 'var(--cds-color-grey-50)',
      padding: isMultiLine ? 'var(--cds-spacing-200)' : 'var(--cds-spacing-150)',
      whiteSpace: 'pre-line',
      fontStyle: isEmpty ? 'italic' : 'normal',
      color: 'var(--cds-color-grey-600)',
    }),
};

type Props = {
  isMultiLine?: boolean;
  children?: React.ReactNode;
};

const ReadOnlyText = ({ isMultiLine = false, children }: Props) => {
  const theme = useTheme();
  return (
    <div css={style.root(theme, isMultiLine, !children)} data-testid="readOnlyText">
      {children || _t('No answer')}
    </div>
  );
};

export default ReadOnlyText;
